import AppComponent from '../../mixins/app-component'

import AppIcon from '../app-icon'

export default
{
    name: 'app-team-indicator',

    mixins: [
        AppComponent
    ],

    components: {
        AppIcon
    },

    props: {
        teams: { type: Array, default: [] },
        teamsPositionsTop: { type: Array, default: [] },
        teamsHeight: { type: Array, default: [] },
        containerHeight: { type: Number, default: 0 }
    },

    data() {
        return {
            activeIndex: -1,
            headerHeight: 0
        }
    },

    watch: {
        teamsPositionsTop: 'onTeamsPositionsTopChange',
        teamsHeight: 'onTeamsHeightChange'
    },

    created() {
        this.elementPosition = 0
        this.elementTranslateY = 0

        if (this.$root.readCookie('page-team:headerHeight')) {
            this.headerHeight = parseInt(this.$root.readCookie('page-team:headerHeight'), 10)
        } else {
            this.eventHub.$on('app-header:mounted', this.onHeaderMounted)
        }

        this.eventHub.$on('application:onEnterFrame', this.onEnterFrame)
        this.eventHub.$on('window:resize', this.onResize)
        this.eventHub.$on('application:routing-step-change', this.onRoutingStepChange)
    },

    mounted() {
        this.ready = true

        if (!this.elementPositionTop || this.elementPositionTop === 0) {
            this.onRoutingStepChange()
        }

        if (this.headerHeight === 0) {
            this.onHeaderMounted()
        }

        this.eventHub.$emit('app-team-indicator:mounted')
    },

    destroyed() {
        this.eventHub.$off('app-header:mounted', this.onHeaderMounted)
        this.eventHub.$off('application:onEnterFrame', this.onEnterFrame)
        this.eventHub.$off('window:resize', this.onResize)
        this.eventHub.$off('application:routing-step-change', this.onRoutingStepChange)
    },

    methods: {
        onResize() {
            this.eventHub.$emit('app-team-indicator:mounted')
            this.onHeaderMounted()
            this._getActiveTeam()
        },

        onHeaderMounted() {
            const $header = document.querySelector('.js-header')
            
            if ($header) {
                this.headerHeight = $header.offsetHeight
                this.eventHub.$emit('application:create-cookie', {
                    name: 'page-team:headerHeight',
                    value: this.headerHeight
                })
            }
        },

        onRoutingStepChange() {
            if (this.$root.routingStep === 3 || this.$root.routingStep === 0) this.elementPositionTop = this.$el.getBoundingClientRect().top
        },

        onEnterFrame() {
            if (this.$root.isTouch) return

            if (this.$root.currScrollTop > 0) {
                this.activeIndex = 0
            }
            this._getActiveTeam(this.$root.currScrollTop)
            if (this.$root.currScrollTop <= 5) {
                this.activeIndex = -1
            }

            if (this.headerHeight > 0 && this.ready) {
                if ((this.$root.currScrollTop) >= this.containerHeight + 300 /* padding-top */ - this.headerHeight - this.$el.offsetHeight - 100) {
                    this.$el.style.transform = `translateX(-100%) translateY(${this.elementTranslateY}px) translateZ(0)`
                } else if (this.$root.currScrollTop >= this.elementPositionTop - this.headerHeight - 100) {
                    this.elementTranslateY = this.$root.currScrollTop - this.elementPositionTop + this.headerHeight + 100
                    this.$el.style.transform = `translateX(-100%) translateY(${this.elementTranslateY}px) translateZ(0)`
                } else {
                    this.$el.style.transform = 'translateX(-100%) translateY(0) translateZ(0)'
                }
            }
        },

        onTeamsPositionsTopChange() {
            this.teamsPositionsTop.forEach((teamPositionTop, index) => {
                this.teams[index].positionTop = teamPositionTop
            })
        },

        onTeamsHeightChange() {
            this.teamsHeight.forEach((height, index) => {
                this.teams[index].height = height
            })
        },

        _getActiveTeam(y) {
            if (this.teamsPositionsTop) {
                this.teams.forEach((team, index) => {
                    if (team.positionTop - this.headerHeight - 100 <= (y + (y * this.$root.content.global.teamColumnsVariation))) {
                        this.activeIndex = index
                    }
                })
            }
        },

        scrollTo(index) {
            if (this.teamsPositionsTop) {
                if (this.teams[index].positionTop) {
                    if (this.teams[index].positionTop <= this.$root.height) {
                        this.eventHub.$emit('page:scroll-to', 1000)
                    } else {
                        this.eventHub.$emit('page:scroll-to', (this.teams[index].positionTop - (this.teams[index].positionTop * this.$root.content.global.teamColumnsVariation)))
                    }
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-team-indicator/script.js